// src/App.jsx
import { useContext, useState } from "react";
import { AuthContext, AuthProvider } from "./context/AuthContext";
import Login from "./components/Login";
import ForgotPassword from "./firebase/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import ResourcePanel from "./pages/ResourcePanel";
import StudentDashboard from "./pages/StudentDashboard";

import "./App.css"; // ensure banner styles are available
import StudentPanel from "./pages/StudentPanel";

function AppContent() {
  const { user, userData } = useContext(AuthContext);

  const [currentView, setCurrentView] = useState("dashboard");
  // views: 'dashboard' | 'admin' | 'uploader' | 'forgot'

  /* ---------------------------
     PUBLIC (no user)
  ---------------------------- */
  if (!user) {
    if (currentView === "forgot") {
      return <ForgotPassword onBack={() => setCurrentView("dashboard")} />;
    }
    return <Login onForgotPassword={() => setCurrentView("forgot")} />;
  }
  
  let page = null;

  if (userData?.role === "student") {
    page = <StudentDashboard />;
  } else if (currentView === "admin" && userData?.role === "admin") {
    page = <AdminDashboard onBackClick={() => setCurrentView("dashboard")} />;
  } else if (
    currentView === "uploader" &&
    (userData?.role === "uploader" || userData?.role === "admin")
  ) {
    page = <ResourcePanel onBackClick={() => setCurrentView("dashboard")} />;
  } else if (currentView === "student" && userData?.role === "admin") {
    page = <StudentPanel onBackClick={() => setCurrentView("dashboard")} />;
  } else {
    page = (
      <Dashboard
        onAdminClick={() => setCurrentView("admin")}
        onResourcePanelClick={() => setCurrentView("uploader")}
        onStudentPanelClick={() => setCurrentView("student")}
      />
    );
  }

  return (
    <>
      <div className="app-top-banner">
        <img src={require("./images/bannar.png")} alt="CIET Logo" className="app-top-banner-logo" />
      </div>
      {page}
    </>
  );

  /* ---------------------------
     AUTHENTICATED LAYOUT
  ---------------------------- */
  // return (
  //   <>
  //     {/* 🔷 CIET Banner ABOVE Learning Resources */}
  //     <div className="app-top-banner">
  //       <img
  //         src={require("./images/bannar.png")}
  //         alt="CIET Logo"
  //         className="app-top-banner-logo"
  //       />
  //     </div>

  //     {/* Page Content */}
  //     {/* {currentView === "admin" && userData?.role === "admin" ? (
  //       <AdminDashboard onBackClick={() => setCurrentView("dashboard")} />
  //     ) : currentView === "uploader" &&
  //       (userData?.role === "uploader" || userData?.role === "admin") ? (
  //       <ResourcePanel onBackClick={() => setCurrentView("dashboard")} />
  //     ) : currentView === "student" && userData?.role === "admin" ? (
  //       <StudentPanel onBackClick={() => setCurrentView("student")} />
  //     ) : (userData?.role === "student") ? (
  //       <StudentDashboard/>
  //     ) : (
  //       <Dashboard
  //         onAdminClick={() => setCurrentView("admin")}
  //         onResourcePanelClick={() => setCurrentView("uploader")}
  //         onStudentPanelClick={() => setCurrentView("student")}
  //       />
  //     )} */}
  //   </>
  // );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
